import React from 'react'
import { BrowserRouter, Switch, Route, Routes } from 'react-router-dom'
import Container from './Components/Container'
import Models from './Components/Models'
import Editor from './Components/Editor'
import model from './data.config'


function Navigation() {
  return (
    <BrowserRouter>
    <Routes>
        <Route path='/' element={<Container data={ model } />}></Route>
        <Route path='/:name' element={<Models data={model} />}> </Route>
        <Route path='/editor' element={<Editor />}> </Route>

    </Routes>
  </BrowserRouter>
  )
}

export default Navigation